
<div class="n-about-mask">
</div>
<div class="n-about-wrap">
    <div class="n-about-container">
        <span class="n-about-close-btn"
            (click)="close()">
            <svg class="icon">
                <use xlink:href="#icon-close"></use>
            </svg>
        </span>
        <p class="n-about-header">
            <img class="icon" *ngIf="logoUrl" [src]="logoUrl" onerror="this.src='assets/images/logo.png'" />
            <svg class="icon" *ngIf="!logoUrl">
                <use xlink:href="#app-icon-black-font-logo"></use>
            </svg>
            DeviceManager
        </p>
        <div class="n-about-content">
            <p class="version"><span>{{i18nLabel.versionLabel}}: </span>{{version}}</p>
            <p><span>{{i18nLabel.urlLabel}}: </span><a [href]="url" target="_blank">{{url}}</a></p>
            <p class="pre-wrap"><span>{{i18nLabel.warningLabel}}: </span>{{warning}}</p>
            <p class="copyright pre-wrap">{{copyright}}</p>
        </div>
        <div [class]="'n-about-footer' + (isJa ?' mb2':'')">
            <button nButton (click)="close()">{{i18nLabel.closeBtn}}</button>
        </div>
    </div>
</div>

